/* SLOVA THEME - assets/slova.js */
(function() {
  function openCart() {
    document.getElementById('cartOverlay').classList.add('open');
    document.getElementById('cartDrawer').classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    document.getElementById('cartOverlay').classList.remove('open');
    document.getElementById('cartDrawer').classList.remove('open');
    document.body.style.overflow = '';
  }
  function formatMoney(cents) {
    return '$' + (cents/100).toLocaleString('es-UY',{minimumFractionDigits:0}) + ' UYU';
  }
  function fetchCart() {
    return fetch('/cart.js').then(function(r){return r.json();});
  }
  function addToCartAPI(vid, qty) {
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:vid,quantity:qty})}).then(function(r){return r.json();});
  }
  function updateLine(key, qty) {
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();});
  }
  function showToast(msg) {
    var el=document.getElementById('toastMsg'); if(el) el.textContent=msg;
    var t=document.getElementById('toast'); if(t){t.classList.add('show');setTimeout(function(){t.classList.remove('show');},2800);}
  }

  /* Lee la cantidad seleccionada en Bundler */
  function getBundlerQty() {
    var hiddenQty = document.querySelector('input[name="quantity"][data-cart-quantity]');
    if(hiddenQty) {
      var qty = parseInt(hiddenQty.getAttribute('data-cart-quantity'));
      if(qty > 0) return qty;
    }
    var activeOption = document.querySelector('.bndlr-radio-container[data-bundler-break-active="true"] input[type="radio"]');
    if(activeOption) {
      var qty2 = parseInt(activeOption.value);
      if(qty2 > 0) return qty2;
    }
    return 1;
  }

  function renderCart(cart) {
    var ce=document.getElementById('cartCount'); if(ce) ce.textContent=cart.item_count;
    var el=document.getElementById('cartItems'), ft=document.getElementById('cartFooter');
    if(!el) return;
    if(!cart.item_count){el.innerHTML='<div class="cart-empty">Tu carrito est\u00e1 vac\u00edo</div>';if(ft)ft.style.display='none';return;}
    if(ft) ft.style.display='block';
    var tot=document.getElementById('cartTotal'); if(tot) tot.textContent=formatMoney(cart.total_price);
    el.innerHTML=cart.items.map(function(item){
      var img=item.image?'<img src="'+item.image+'" style="width:100%;height:100%;object-fit:cover">':'';
      return '<div class="cart-item"><div class="cart-item-img">'+img+'</div><div class="cart-item-info"><div class="cart-item-name">'+item.product_title+'</div><div class="cart-item-variant">'+((item.variant_title && item.variant_title!=='Default Title')?item.variant_title:'')+'</div><div class="cart-item-row"><div class="cart-item-qty"><button class="ciq-btn" data-key="'+item.key+'" data-qty="'+(item.quantity-1)+'">\u2212</button><span class="ciq-num">'+item.quantity+'</span><button class="ciq-btn" data-key="'+item.key+'" data-qty="'+(item.quantity+1)+'">+</button></div><span class="cart-item-price">'+formatMoney(item.line_price)+'</span><button class="cart-item-remove" data-key="'+item.key+'" data-qty="0">\u00d7</button></div></div></div>';
    }).join('');
    el.querySelectorAll('[data-key]').forEach(function(btn){btn.onclick=function(){updateLine(this.getAttribute('data-key'),parseInt(this.getAttribute('data-qty'))).then(renderCart);};});
  }

  function init() {
    /* Cart */
    var ob=document.getElementById('btnOpenCart'); if(ob) ob.onclick=function(){fetchCart().then(function(c){renderCart(c);openCart();});};
    var cb=document.getElementById('btnCloseCart'); if(cb) cb.onclick=closeCart;
    var ov=document.getElementById('cartOverlay'); if(ov) ov.onclick=closeCart;

    /* ATC */
    var atc=document.getElementById('btnPAddToCart');
    if(atc) atc.onclick=function(){
      var vid=parseInt(this.getAttribute('data-variant'));
      if(!vid)return;
      var qty=getBundlerQty();
      var orig=this.textContent;
      this.textContent='Agregando...';
      addToCartAPI(vid,qty).then(fetchCart).then(function(c){
        renderCart(c);
        atc.textContent=orig;
        showToast('Agregado al carrito');
        openCart();
      });
    };

    /* Buy now */
    var bn=document.getElementById('btnPBuyNow');
    if(bn) bn.onclick=function(){
      var vid=parseInt(this.getAttribute('data-variant'));
      if(!vid)return;
      var qty=getBundlerQty();
      addToCartAPI(vid,qty).then(function(){
        window.location.href='/checkout';
      });
    };

    /* Qty manual */
    var pq=1,pqn=document.getElementById('pQtyNum');
    var qm=document.getElementById('btnPQtyMinus'); if(qm) qm.onclick=function(){pq=Math.max(1,pq-1);if(pqn)pqn.textContent=pq;};
    var qp=document.getElementById('btnPQtyPlus'); if(qp) qp.onclick=function(){pq++;if(pqn)pqn.textContent=pq;};

    /* Tabs */
    document.querySelectorAll('.tab-btn').forEach(function(b){b.onclick=function(){var p=this.closest('.tabs');p.querySelectorAll('.tab-btn').forEach(function(x){x.classList.remove('active');});p.querySelectorAll('.tab-content').forEach(function(x){x.classList.remove('active');});this.classList.add('active');var t=document.getElementById('tab-'+this.getAttribute('data-tab'));if(t)t.classList.add('active');};});

    /* FAQ */
    document.querySelectorAll('.faq-q, .tfaq-q').forEach(function(q){q.onclick=function(){var item=this.parentElement,was=item.classList.contains('open');item.closest('section, .tabs').querySelectorAll('.faq-item, .tfaq-item').forEach(function(i){i.classList.remove('open');});if(!was)item.classList.add('open');};});

    /* Gallery */
    document.querySelectorAll('.gthumb').forEach(function(t){t.onclick=function(){document.querySelectorAll('.gthumb').forEach(function(x){x.classList.remove('active');});this.classList.add('active');var src=this.getAttribute('data-src');if(src){var main=document.getElementById('galleryMainImg');if(main)main.src=src;}};});

    /* Init cart count */
    fetchCart().then(function(c){var el=document.getElementById('cartCount');if(el)el.textContent=c.item_count;});
  }

  document.addEventListener('DOMContentLoaded', init);
})();